import {createAction} from '@reduxjs/toolkit';
import {GetBeersDTO} from 'typescript/dto/beersDto';
import {withPayloadType} from 'typescript/types/PayloadType';

import {beerStyleViewNamespace} from './beerStyleViewSlice';

const getSingleBeerStyleACS = createAction(
  `${beerStyleViewNamespace}/getSingleBeerStyleACS`,
  withPayloadType<string>(),
);

const getBeerStyleBeersACS = createAction(
  `${beerStyleViewNamespace}/getBeerStyleBeersACS`,
  withPayloadType<GetBeersDTO>(),
);

export {getSingleBeerStyleACS, getBeerStyleBeersACS};
